/* istanbul ignore file */

import styled from 'styled-components';
import { colors, medias } from 'assets/styled/tokens';

export const DashWrapper = styled.div<{ isLoading?: boolean }>`
  opacity: ${({ isLoading = false }) => (isLoading ? '0.5' : '1')};
  pointer-events: ${({ isLoading = false }) => (isLoading ? 'none' : 'all')};
  background: #f5f3f1;
`;

export const DashGrid = styled.div`
  display: grid;
  align-content: center;
  margin-right: -12px;
  margin-left: -12px;
`;

export const DashHalfGrid = styled(DashGrid)`
  grid-template-columns: 100%;

  @media screen and (min-width: ${medias.desktopSm}) {
    grid-template-columns: 50% 50%;
  }
`;

export const DashFullGrid = styled(DashGrid)`
  grid-template-columns: 100%;
`;

export const DashColumn = styled.div`
  padding: 12px;
`;

export const DashHeader = styled.header`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  position: relative;

  @media screen and (max-width: ${medias.tablet}) {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  h1 {
    margin-right: 32px;
    font-size: 32px;
  }
`;
export const OldChartButton = styled.button`
  width: 195px;
  height: 32px;
  border-radius: 4px;
  border: none;
  text-decoration: underline;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-align: left;
  color: #f38a00;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  margin-left: auto;

  @media screen and (max-width: ${medias.tablet}) {
    margin-left: 0;
    margin: 0 auto;
  }
`;
export const LeftSpace = styled.div`
  display: flex;
  align-items: center;
`;
export const TechinicalHoursButton = styled.button`
  height: 32px;
  width: 216px;
  margin-left: 15px;
  padding: 8px;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  justify-content: space-around;
  font-family: Roboto;
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  display: flex;
  align-items: center;
  letter-spacing: 0.5px;
  color: ${colors.carbon};
  border-radius: 4px;
`;
